import { render } from "./PharmacyAndDme.vue?vue&type=template&id=7509ad87&ts=true"
import script from "./PharmacyAndDme.ts?vue&type=script&lang=ts&external"
export * from "./PharmacyAndDme.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__